export default {
  // 微信应用
  WECHAT_APPLICATION: "WeChat Application",
  WECHAT_APPLICATION_CREATE: "Create WeChat Application",
  WECHAT_APPLICATION_CREATE_SUCCESS: "Create WeChat Application Successful",
  WECHAT_APPLICATION_UPDATE: "Update WeChat Application",
  WECHAT_APPLICATION_UPDATE_SUCCESS: "Update WeChat Application Successful",
  WECHAT_APPLICATION_NAME: "Name",
  WECHAT_APPLICATION_NAME_REQUIRED: "Wechat application name is required",
  WECHAT_APPLICATION_APP_ID: "APP ID",
  WECHAT_APPLICATION_APP_ID_REQUIRED: "WeChat application ID is required",
  WECHAT_APPLICATION_APP_SECRET: "APP Secret",
  WECHAT_APPLICATION_APP_SECRET_REQUIRED: "WeChat Application Secret is required",
  WECHAT_APPLICATION_TYPE: "Type",
  WECHAT_APPLICATION_TYPE_OFFICIAL: "Official",
  WECHAT_APPLICATION_TYPE_APPLET: "Applet",
  WECHAT_APPLICATION_TYPE_REQUIRED: "WeChat application type is required",
  
  // 邮件模版
  WECHAT_MESSAGE_TEMPLATE: "WeChat Message Template",
  WECHAT_MESSAGE_TEMPLATE_CREATE: "Create WeChat Message Template",
  WECHAT_MESSAGE_TEMPLATE_CREATE_SUCCESS: "Create WeChat Message Template Successful.",
  WECHAT_MESSAGE_TEMPLATE_UPDATE: "Update WeChat Message Template",
  WECHAT_MESSAGE_TEMPLATE_UPDATE_SUCCESS: "Update WeChat Message Template Successful.",
  WECHAT_MESSAGE_TEMPLATE_APPLICATION_ID: "Application ID",
  WECHAT_MESSAGE_TEMPLATE_APPLICATION_ID_REQUIRED: "Please select application ID",
  WECHAT_MESSAGE_TEMPLATE_CODE: "Code",
  WECHAT_MESSAGE_TEMPLATE_CODE_REQUIRED: "WeChat Message template code is required",
  WECHAT_MESSAGE_TEMPLATE_NAME: "Name",
  WECHAT_MESSAGE_TEMPLATE_NAME_REQUIRED: "WeChat Message template name is required",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_ID: "WeChat Template ID",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_ID_REQUIRED: "Please input wechat template Id",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_TITLE: "WeChat Template Title",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_TITLE_REQUIRED: "Please input wechat template title",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD1: "Keyword1",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD2: "Keyword2",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD3: "Keyword3",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD4: "Keyword4",
  WECHAT_MESSAGE_TEMPLATE_TEMPLATE_KEYWORD5: "Keyword5",
  WECHAT_MESSAGE_TEMPLATE_PAGE_URL: "Page URL",
};
